var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.491,
    height: 17,
    viewBox: "0 0 19.491 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.405,15.315H1.685V1.685h8.72V2.979h1.685V.879A.879.879,0,0,0,11.211,0H.879A.879.879,0,0,0,0,.879V16.121A.879.879,0,0,0,.879,17H11.211a.879.879,0,0,0,.879-.879v-2.1H10.405Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M79.728,68.774,74.746,65v2.528H65v2.418h9.746v2.528Z",
    transform: "translate(-60.237 -60.237)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.ff112df5233db19892d69f5fcc9bca6c.svg";
export { ForwardRef as ReactComponent };